import {FormService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced:true,
    state:{
        forms:[],
        selectedForm: undefined,
    },
    mutations:{
        saveWaitingForms(current, forms) {
            current.forms.splice(0);
            current.forms = forms;
        },
        saveSelectedForm(current, form){
            current.selectedForm = {...form};
        }
    },

    actions:{
        async getFormAction({ commit}, id) {
            await bindLoading(commit, async () => commit('saveSelectedForm', await FormService.getForm(id)), 'form')
        }
    }

}